import { render, staticRenderFns } from "./finishNumber.vue?vue&type=template&id=14a9310f&scoped=true&"
import script from "./finishNumber.vue?vue&type=script&lang=js&"
export * from "./finishNumber.vue?vue&type=script&lang=js&"
import style0 from "./finishNumber.vue?vue&type=style&index=0&id=14a9310f&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14a9310f",
  null
  
)

export default component.exports